// Simple JSON parsing helper
export const parseJSON = (data) => {
  if (!data) return null;
  try {
    return typeof data === "string" ? JSON.parse(data) : data;
  } catch (error) {
    return data;
  }
};

// Enhanced function to deeply parse nested JSON strings
export const parseNestedJSON = (data) => {
  if (!data) return null;

  const parseRecursively = (obj) => {
    if (typeof obj !== "object" || obj === null) {
      if (typeof obj === "string") {
        try {
          const parsed = JSON.parse(obj);
          return parseRecursively(parsed);
        } catch (e) {
          return obj;
        }
      }
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => parseRecursively(item));
    }

    const result = {};
    for (const key in obj) {
      result[key] = parseRecursively(obj[key]);
    }

    return result;
  };

  try {
    const initialParsed = typeof data === "string" ? JSON.parse(data) : data;
    return parseRecursively(initialParsed);
  } catch (error) {
    return data;
  }
};

// Function to parse relevant indices
export const parseRelevantIndices = (responseData) => {
  if (!responseData) return [];

  try {
    const parsed = parseJSON(responseData);

    // Handle array format
    if (Array.isArray(parsed)) {
      return parsed.map((i) => i.toString());
    }

    // Handle string format like "{\"0\",\"1\",\"3\",\"5\"}"
    if (typeof parsed === "string") {
      const matches = parsed.match(/\d+/g);
      return matches || [];
    }

    return [];
  } catch (error) {
    return [];
  }
};
